export interface AdminUserDetails {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface AdminUser {
  id: number;
  user: AdminUserDetails;
  isQnaFacilitator?: boolean;
}

interface CustomWidget {
  title: string;
  body: string;
}

export enum AdditionalResourceStatus {
  UPLOADING = 'UPLOADING',
  SUCCESS = 'SUCCESS',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  PROCESSED = 'PROCESSED',
}

export interface AdditionalResource {
  id: number;
  name: string;
  type: string;
  size: number;
  url: string;
  status?: AdditionalResourceStatus;
  uniqueId?: string;
  uploadedFile?: File;
}

export interface IEmbedDataRequest {
  id: number;
  completed?: boolean;
  processedFiles: number[];
  failedFiles?: number[];
}
export interface HelpOptions {
  courseAdminUsers?: AdminUser[];
  hasAiLearningAssistantEnabled?: boolean;
  hasHelpResourcesEnabled?: boolean;
  courseHelp?: CustomWidget;
  hasAiEmbeddingInProgress?: boolean;
  embedDataRequests?: IEmbedDataRequest[];
  additionalResources?: AdditionalResource[];
  hasAdditionalResourcesChanged?: boolean;
}

export interface HelpOptionsSettingsResponse {
  result: HelpOptions;
  message: string;
}


export interface IHelpOptionsSettingsPayload {
  userCourseIds: number[];
  hasAiLearningAssistantEnabled: boolean;
  hasHelpResourcesEnabled: boolean;
  courseHelp: {
    title: string;
    body: string;
  };
  additionalResourceIds?: number[];
}
